import { render, staticRenderFns } from "./PieChartProdutosMaisVendidos.vue?vue&type=template&id=d9f7b5a6&"
import script from "./PieChartProdutosMaisVendidos.vue?vue&type=script&lang=js&"
export * from "./PieChartProdutosMaisVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports